import { configureStore } from "@reduxjs/toolkit";
import { sharedSlice, authReducer, videosSlice } from "../services";
// import authReducer from "../services/authSlice";
import { githubApi } from "../services/gitHubApi";

export default configureStore({
  reducer: {
    auth: authReducer,
    share: sharedSlice,
    videos: videosSlice,
    [githubApi.reducerPath]: githubApi.reducer,
  }
});
